import type { QSetReviewTaskContextData } from '../providers';
import type { QSetReviewTaskDetailsFormInput } from '../schemas';

function mapSubtasksToFormData(data?: QSetReviewTaskContextData['mainTaskDetail']['subtasks']) {
  if (!data) {
    return {
      key: {
        assignee: {
          label: '',
          value: '',
          inputValue: '',
        },
        dueDate: new Date(),
        qSetId: '',
      },
    };
  }

  const mappedData: QSetReviewTaskDetailsFormInput['subtask'] = {};

  for (const value of Object.values(data)) {
    if (!value.code) {
      continue;
    }
    mappedData[value.code] = {
      assignee: {
        label: `${value.assignee?.firstname} ${value.assignee?.lastname}`,
        value: value.assignee?.id ?? '',
        inputValue: `${value.assignee?.firstname} ${value.assignee?.lastname}`,
      },
      dueDate: value.dueDate ?? new Date(),
      qSetId: value.qsetId ?? '',
    };
  }
  return mappedData;
}

export default function mapTaskDetailsToFormData(
  mainTaskDetail?: QSetReviewTaskContextData['mainTaskDetail'],
) {
  if (!mainTaskDetail) {
    return {
      mainTask: {
        name: '',
        assignee: {
          label: '',
          value: '',
          inputValue: '',
        },
        dueDate: new Date(),
      },
      subtask: {
        key: {
          assignee: {
            label: '',
            value: '',
            inputValue: '',
          },
          qSetId: '',
          dueDate: new Date(),
        },
      },
    };
  }
  const mappedData: QSetReviewTaskDetailsFormInput = {
    mainTask: {
      name: mainTaskDetail.name ?? '',
      assignee: {
        label: `${mainTaskDetail.assignee?.firstname} ${mainTaskDetail.assignee?.lastname}`,
        value: mainTaskDetail.assignee?.id ?? '',
        inputValue: `${mainTaskDetail.assignee?.firstname} ${mainTaskDetail.assignee?.lastname}`,
      },
      dueDate: mainTaskDetail.dueDate ?? new Date(),
    },
    subtask: mapSubtasksToFormData(mainTaskDetail.subtasks),
  };
  return mappedData;
}
